import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Optional,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { combineLatest, firstValueFrom, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GameSettingsService } from 'src/app/core/firebase/gameSettings.service';
import { GameThemeSettingsDispatcher } from 'src/app/core/state/gameThemeSettings/gameThemeSettings.dispatcher';
import { CardStyle } from 'src/app/core/state/gameThemeSettings/gameThemeSettings.state';
import { SOPO_DIALOG_DATA, SopoDialogRef } from 'src/app/sopo-popup/interfaces/dialog';
import { SopoPopupService } from 'src/app/sopo-popup/service/sopo-popup.service';
import SwiperCore, { Navigation, SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';

SwiperCore.use([Navigation]);

@Component({
    selector: 'app-cards',
    templateUrl: './cards.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./cards.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CardsComponent implements OnInit, OnDestroy {

    @Input() cardStylesArray: CardStyle[];
    @ViewChild('cardSlide') cardSlide: SwiperComponent;
    activeCardStyle$: Observable<CardStyle>;
    mycardStyles$: Observable<CardStyle[]>;
    sliderOptions: SwiperOptions = {
        slidesPerView: 4,
        pagination: false,
        navigation: true,
    };

    constructor(
        private gameThemeSettingsDispatcher: GameThemeSettingsDispatcher,
        private gameSettingsService: GameSettingsService,
        private popoverController: PopoverController,
        @Optional() public sopoDialogRef: SopoDialogRef,
        private sopoPopupService: SopoPopupService,
    ) {}

    ngOnInit() {
        this.activeCardStyle$ = this.gameThemeSettingsDispatcher.getActiveCardStyle();
        const myCardStylesState$ = this.gameThemeSettingsDispatcher.getMyCardStylesState();
        if (this.cardStylesArray) {
            this.mycardStyles$ = myCardStylesState$.pipe(
                map(mycardStyles => this.gameSettingsService.mergeItems(mycardStyles, this.cardStylesArray)),
            );
        } else {
            const cardStylesArrayPromise = this.gameSettingsService.loadAllItemsFromCms<CardStyle>('cardStyles');
            this.mycardStyles$ = combineLatest([cardStylesArrayPromise, myCardStylesState$]).pipe(
                map(([cardStylesArray, mycardStyles]) => this.gameSettingsService.mergeItems(mycardStyles, cardStylesArray)),
            );
        }
    }

    async onSelect(cardStyle: CardStyle) {
        const activeCardStyle = await firstValueFrom(this.activeCardStyle$);
        if (cardStyle.id === activeCardStyle.id) return;
        if (this.sopoDialogRef) this.sopoDialogRef.close();
        else if (!this.cardStylesArray) this.popoverController.dismiss();
        this.gameSettingsService.markItemAsPurchasedAndSelect<CardStyle>(cardStyle, 'cardStyles');
        //Purchase and select logic DISABLED
        return;
        if(!cardStyle.purchased){
        this.sopoPopupService
            .promptForConfirmation('app', {
                data: {
                    header: `Are you sure you want to purchase this item for ${cardStyle.price} diamonds?`,
                    okText: `Yes`,
                    cancelText: 'No'
                }
            })
            .then((confirmed) => {
                if (confirmed) {
                    this.gameSettingsService.selectAndPurchaseItem<CardStyle>(cardStyle, 'cardStyles');
                }
            });
        }
        else {
            this.gameSettingsService.selectAndPurchaseItem<CardStyle>(cardStyle, 'cardStyles');
        }
    }

    getCard(name: string){
        return '/assets/img/cardStyles/' + name + '.png';
    }

    trackCards(index: number, card: CardStyle): string {
        return card.id.toString();
    }
    
    ngOnDestroy(): void {
    }
}
